<template>
  <div></div>
</template>

<script>
import Vue from "vue";
import store from "@/store";

export default {
  name: "authCallback",
  async beforeRouteEnter(routeTo, RouteFrom, next) {
    let params = new URLSearchParams(window.location.search);
    let token = params.get('token');
    let code = params.get('code');

    let processLinkingLogin = store.getters['user/getProcessLinkingLogin'];

    if (code == 'user_not_exists') {
      if (processLinkingLogin) {
        let payload = {
          provider: params.get('login_provider'),
          provider_id: params.get('login_provider_id'),
          token: token,
        };

        await store
            .dispatch('user/linkOauthLogin', JSON.stringify(payload))
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                let authParam = store.getters["user/getAuthParam"];
                let url = '/dashboard/settings';
                let redirect = routeTo.query.redirect || url;
                if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
                  redirect = '/dashboard/blog';
                }
                
                store.commit("user/SET_ADMIN_TRIGGER", false);

                Vue.swal({
                  target: document.getElementById("main"),
                  text: response.data.message,
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });

                next((vm) => {
                  vm.$router.push(redirect);
                });
              }
            })
            .catch((error) => {

              let authParam = store.getters["user/getAuthParam"];
              let url = '/dashboard/settings';
              let redirect = routeTo.query.redirect || url;
              if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
                redirect = '/dashboard/blog';
              }
              
              next((vm) => {
                if (error instanceof TypeError) {
                  Vue.swal({
                    target: document.getElementById("main"),
                    text: vm.$vuetify.lang.t(
                      "$vuetify.view.restore.error"
                    ),
                    icon: "error",
                    timer: 4000,
                    toast: true,
                    position: "top-right",
                    showConfirmButton: false,
                  });
                }
                
                if (error.error === "user_exists") {
                  Vue.swal({
                    target: document.getElementById("main"),
                    text: vm.$vuetify.lang.t(
                      "$vuetify.view.restore.user_exists"
                    ),
                    icon: "error",
                    timer: 4000,
                    toast: true,
                    position: "top-right",
                    showConfirmButton: false,
                  });
                }


                vm.$router.push(redirect);
              });
            });
      } else {
        // one-time token proves the Google/Apple sign-in when the registration form is sent
        store.commit("user/SET_LOGIN_PROVIDER", {
          provider: params.get('login_provider'),
          provider_id: params.get('login_provider_id'),
          token: token,
        });

        next((vm) => {
          vm.$router.replace("/registration");
        });
      }
    } else if (code == 'user_login') {
      if (processLinkingLogin) {
        let authParam = store.getters["user/getAuthParam"];
        let url = '/dashboard/settings';
        let redirect = routeTo.query.redirect || url;
        if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
          redirect = '/dashboard/blog';
        }
        next((vm) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: vm.$vuetify.lang.t(
              "$vuetify.view.restore.user_exists"
            ),
            icon: "error",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          vm.$router.push(redirect);
        });
      } else {
        store.commit("user/SET_AUTH_TOKEN", token);
        await store.dispatch('user/getProfile');

        let redirectUrl = store.getters['user/getRedirect'];
        let authParam = store.getters["user/getAuthParam"];
        let url = '/dashboard/main';
        let redirect = redirectUrl || url;
        if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
          redirect = '/dashboard/blog';
        }
        store.commit("user/SET_ADMIN_TRIGGER", false);
        next((vm) => {
          vm.$router.push(redirect);
        });
      }
    } else if (code == 'user_deleted') {
      if (processLinkingLogin) {
        let authParam = store.getters["user/getAuthParam"];
        let url = '/dashboard/settings';
        let redirect = routeTo.query.redirect || url;
        if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
          redirect = '/dashboard/blog';
        }
        next((vm) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: vm.$vuetify.lang.t(
              "$vuetify.view.restore.user_exists"
            ),
            icon: "error",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          vm.$router.push(redirect);
        });
      } else {
        store.commit("user/SET_AUTH_TOKEN", token);
        next((vm) => {
          vm.$router.replace("/restore");
        });
      }
    } else {
      next((vm) => {
        vm.$router.replace("/auth");
      });
    }
  }
};
</script>

<style scoped></style>
